/* eslint-disable no-restricted-globals */
import React, { Component } from 'react'
import {
  updateQueryStringBatch,
  parseStateFromUrl
} from '@intentive/interactive-graphics'
import { format } from 'd3-format'

//import flatData from '../../data/v3-min-data_visualization_acs_2017_t_i_cb_20190702.csv'
import flatData from '../../data/v3_min_data_visualization_acs_2019_t_i_cb.csv'

import StackedBarChart from '../StackedBarChart/'

import Header from '../Header'
import Controls from './Controls/'
import Legend from '../Legend'
import Footer from '../Footer/'
import filterData from './filterData'
import styles from './styles.module.css'
import {
  defaultPlace,
  placeKey,
  valueKey,
  costBurdenBinKey,
  defaultAmiMethod,
  tenureTypes,
  amiMethods,
  costBurdenThresholds,
  defaultTenure,
  defaultCostBurdenThreshold,
  colorHash,
  sourceText,
  amiMethodKey,
  amiBinKey,
  tenureKey,
  amiBinSortOrder,
  costBurdenKey,
  tooltipColorKeyLabels
} from './constants'

export default class CostBurdenVis extends Component {
  constructor(props) {
    super(props)

    // console.log('styles', styles)

    // console.log('flat data from csv', flatData)

    //
    // uncomment to parse unique tenure types from the data
    //
    // const tenureTypes = new Set()
    // flatData.forEach(d => {
    //   tenureTypes.add(d.tenure)
    // })
    // // console.log('tenureTypes', Array.from(tenureTypes))

    // set default starting values
    let place = defaultPlace
    let costBurdenThreshold = defaultCostBurdenThreshold

    let tenure = defaultTenure
    let amiMethod = defaultAmiMethod

    // read the query string in the url
    // parse out and apply any filters found there
    const url = new URL(window.location)
    const params = new URLSearchParams(url.search)

    // override starting values if they are found in the url
    for (let entry of params.entries()) {
      const key = decodeURIComponent(entry[0])
      const value = decodeURIComponent(entry[1])
      if (key === 'place') place = value
      else if (key === 'costBurdenThreshold') costBurdenThreshold = value
      else if (key === 'tenure') tenure = value
      else if (key === 'amiMethod') amiMethod = value
    }

    // parse out a list of places and cost burden thresholds
    const places = Array.from(new Set(flatData.map(d => d[placeKey])))

    window.addEventListener('resize', this.handleWindowSizeChange)

    const initialState = {
      width: window.innerWidth,
      height: 600,
      places,
      flatData,
      view: 'page',
      // filter values vv
      tenure,
      amiMethod,
      costBurdenThreshold,
      place
    }

    const ignoredKeys = ['width', 'height', 'places', 'flatData']
    if (typeof parseStateFromUrl === 'function') {
      this.state = parseStateFromUrl({ initialState, ignoredKeys })
    } else {
      this.state = initialState
    }
  }

  onFilterChange(type, selectedItem) {
    // console.log('updateQueryStringBatch', updateQueryStringBatch)

    // update the url
    updateQueryStringBatch({
      [type]: selectedItem
    })

    if (
      selectedItem !== '' &&
      selectedItem !== null &&
      selectedItem !== undefined
    ) {
      this.setState({ [type]: selectedItem })
    } else {
      console.error(`invalid filter type ${type}`)
    }
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth })
  }

  render() {
    const {
      place,
      costBurdenThreshold,
      tenure,
      amiMethod,
      width,
      places,
      flatData,
      view
    } = this.state

    const xKey = amiBinKey

    // console.log('xKey', xKey)

    const filteredData = filterData({
      data: flatData,
      costBurdenThreshold,
      place,
      tenure,
      placeKey,
      xKey,
      costBurdenBinKey,
      valueKey,
      tenureKey,
      amiBinKey,
      amiMethodKey,
      amiMethod,
      amiBinSortOrder,
      costBurdenKey
    })

    // console.log('filteredData', filteredData)
    // console.log('places', places)
    // console.log('filteredData', filteredData)

    const colorKeyLabels = {
      above: `Cost Burdened (more than ${costBurdenThreshold}% of income for housing)`,
      below: 'Non-Cost Burdened'
    }

    const lines = [
      { title: colorKeyLabels.above, color: colorHash.above },
      {
        title: colorKeyLabels.below,
        color: colorHash.below
      }
    ]

    const valueFormat = format(',.0f')

    const tooltipContent = d => {
      const xKeyFormatted = d[xKey].replace(/\sto\s/, '-')
      const costStatusText = tooltipColorKeyLabels[d.position]
      return (
        <div className="tooltip-content">
          <p>{`${valueFormat(
            d[valueKey]
          )} ${costStatusText} households in the ${xKeyFormatted} AMI category`}</p>
        </div>
      )
    }

    const oKey = xKey
    const rKey = valueKey
    const colorKey = 'position'

    return (
      <div className={styles.costBurden}>
        <Header />
        <Controls
          place={place}
          tenure={tenure}
          amiMethod={amiMethod}
          costBurdenThreshold={costBurdenThreshold}
          places={places}
          tenureTypes={tenureTypes}
          amiMethods={amiMethods}
          costBurdenThresholds={costBurdenThresholds}
          onPlaceChange={this.onFilterChange.bind(this, 'place')}
          onTenureChange={this.onFilterChange.bind(this, 'tenure')}
          onAmiMethodChange={this.onFilterChange.bind(this, 'amiMethod')}
          onCostBurdenThresholdChange={this.onFilterChange.bind(
            this,
            'costBurdenThreshold'
          )}
        />
        <div className={styles.vis}>
          <div className={styles.yAxisLabel}>Households</div>
          <StackedBarChart
            data={filteredData}
            oKey={oKey}
            rKey={rKey}
            colorKey={colorKey}
            colorHash={colorHash}
            tooltipContent={tooltipContent}
          />
        </div>
        <Legend width={width} height={20} lines={lines} />
        <div className={styles.legendContainer} />
        <Footer view={view} sourceText={sourceText} />
      </div>
    )
  }
}
